import React, { useCallback } from 'react'
import PropTypes from 'prop-types'
import clsx from 'clsx'
import Icon from '../../../../atoms/Icon'

function PageButton ({ iconStart, iconEnd, children, disabled, onClick }) {
  const handleClick = useCallback((e) => {
    if (!disabled) {
      onClick(e)
    }
  }, [disabled, onClick])

  const cn = clsx('flex flex-row items-center gap-xs py-1 px-0 select-none radius-xs opal-surface-default', {
    disabled: disabled,
    clickable: !disabled
  })

  return (
    <div role='button' className={cn} onClick={handleClick}>
      {iconStart ? (<Icon name={iconStart} />) : null}
      {children}
      {iconEnd ? (<Icon name={iconEnd} />) : null}
    </div>
  )
}

PageButton.propTypes = {
  children: PropTypes.node,
  iconStart: PropTypes.string,
  iconEnd: PropTypes.string,
  disabled: PropTypes.bool,
  onClick: PropTypes.func
}

function Paging ({
  pagingInfo,
  canNext,
  canPrev,
  onNext,
  onPrev,
  pageSize,
  onPageSizeChange,
  pageSizeOptions
}) {
  if (!pagingInfo) return null

  return (
    <div className='og-paging'>
      <div className='flex flex-row justify-between items-center'>
        <div className='flex flex-row items-center gap-md'>
          <div>
            {pagingInfo.total === 0
              ? 'No Data Available'
              : (
                <>
                  Showing: <strong>{pagingInfo.start}</strong> - <strong>{pagingInfo.end}</strong> of <strong>{pagingInfo.total}</strong>
                </>
              )}
          </div>
          {pageSizeOptions && onPageSizeChange && (
            <div className='flex flex-row items-center gap-xs'>
              <label htmlFor='page-size-select' className='text-sm'>
                Rows per page:
              </label>
              <select
                id='page-size-select'
                value={pageSize}
                onChange={(e) => onPageSizeChange(Number(e.target.value))}
                className='opal-input'
              >
                {pageSizeOptions.map(size => (
                  <option key={size} value={size}>
                    {size}
                  </option>
                ))}
              </select>
            </div>
          )}
        </div>
        <div className='flex flex-row gap-sm'>
          <PageButton
            iconStart='chevronLeft'
            disabled={!canPrev}
            onClick={onPrev}
          >
            Prev
          </PageButton>
          <PageButton
            iconEnd='chevronRight'
            disabled={!canNext}
            onClick={onNext}
          >
            Next
          </PageButton>
        </div>
      </div>
    </div>
  )
}

Paging.propTypes = {
  pagingInfo: PropTypes.shape({
    start: PropTypes.number,
    end: PropTypes.number,
    total: PropTypes.number
  }),
  canNext: PropTypes.bool.isRequired,
  canPrev: PropTypes.bool.isRequired,
  onNext: PropTypes.func.isRequired,
  onPrev: PropTypes.func.isRequired,
  pageSize: PropTypes.number,
  onPageSizeChange: PropTypes.func,
  pageSizeOptions: PropTypes.arrayOf(PropTypes.number)
}

export default Paging
